import { c as _c } from "react/compiler-runtime";
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Input, type InputProps } from 'antd';
import React from 'react';
interface AuthPasswordInputProps extends InputProps {
  errorMessage?: string;
  label?: string;
}
export const AuthPasswordInput = t0 => {
  const $ = _c(16);
  let errorMessage;
  let label;
  let props;
  if ($[0] !== t0) {
    ({
      errorMessage,
      label,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = errorMessage;
    $[2] = label;
    $[3] = props;
  } else {
    errorMessage = $[1];
    label = $[2];
    props = $[3];
  }
  const renderPaswordInputIcon = _temp;
  const t1 = errorMessage ? "error" : undefined;
  const t2 = errorMessage ? "#ED3F3F" : "#FFFFFF1A";
  let t3;
  if ($[4] !== t2) {
    t3 = {
      borderColor: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t3) {
    t4 = <Input.Password iconRender={renderPaswordInputIcon} size="large" className="border-[#FFFFFF1A w-full rounded-lg border-2 h-[42px] px-[11px] text-[100%] bg-transparent" status={t1} style={t3} {...props} />;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== errorMessage) {
    t5 = errorMessage && <span className="text-[14px] text-base text-[#ED3F3F]">{errorMessage}</span>;
    $[10] = errorMessage;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== label || $[13] !== t4 || $[14] !== t5) {
    t6 = <label className="flex flex-col gap-1 text-base text-[#AAAAB6]">{label}{t4}{t5}</label>;
    $[12] = label;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
function _temp(visible) {
  if (visible) {
    return <EyeInvisibleOutlined style={{
      color: "#3D63E8"
    }} />;
  }
  return <EyeOutlined style={{
    color: "#AAAAB6"
  }} />;
}